import React from 'react';
import { Music, Calendar, FileText, Users, Lock } from 'lucide-react';

export default function StatsGrid({ stats, bandData, setActiveTab, isPremium }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {/* Total Songs */}
      <button
        onClick={() => setActiveTab('songs')}
        className="card-3d hover:bg-white/15 rounded-card p-4 transition text-left"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="bg-brand/20 p-2 rounded-lg">
            <Music className="w-5 h-5 text-brand" />
          </div>
          <div>
            <p className="text-2xl font-bold">{stats.totalSongs}</p>
            <p className="text-xs text-text-subtle">Total Songs</p>
          </div>
        </div>
        <p className="text-xs text-text-subtle mt-2">{stats.totalVersions} versions</p>
      </button>

      {/* Upcoming Gigs */}
      <button
        onClick={() => setActiveTab('gigs')}
        className="card-3d hover:bg-white/15 rounded-card p-4 transition text-left"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="bg-blue-500/20 p-2 rounded-lg">
            <Calendar className="w-5 h-5 text-blue-400" />
          </div>
          <div>
            <p className="text-2xl font-bold flex items-center gap-2">
              {isPremium ? stats.upcomingGigs : 0}
              {!isPremium && <Lock className="w-4 h-4 text-yellow-400" />}
            </p>
            <p className="text-xs text-text-subtle">Upcoming Gigs</p>
          </div>
        </div>
        <p className="text-xs text-text-subtle mt-2">{isPremium ? `${stats.totalGigs} total` : 'Premium feature'}</p>
      </button>

      {/* Documents */}
      <button
        onClick={() => setActiveTab('documents')}
        className="card-3d hover:bg-white/15 rounded-card p-4 transition text-left"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="bg-green-500/20 p-2 rounded-lg">
            <FileText className="w-5 h-5 text-green-400" />
          </div>
          <div>
            <p className="text-2xl font-bold">{stats.totalDocuments}</p>
            <p className="text-xs text-text-subtle">Documents</p>
          </div>
        </div>
        <p className="text-xs text-text-subtle mt-2">Press kit files</p>
      </button>

      {/* Band Members */}
      <button
        onClick={() => setActiveTab('settings')}
        className="card-3d hover:bg-white/15 rounded-card p-4 transition text-left"
      >
        <div className="flex items-center gap-3 mb-2">
          <div className="bg-orange-500/20 p-2 rounded-lg">
            <Users className="w-5 h-5 text-orange-400" />
          </div>
          <div>
            <p className="text-2xl font-bold">{bandData?.members ? Object.keys(bandData.members).length : 0}</p>
            <p className="text-xs text-text-subtle">Band Members</p>
          </div>
        </div>
        <p className="text-xs text-text-subtle mt-2">Active collaborators</p>
      </button>
    </div>
  );
}
